<template>
  <div class="flex h-full gap-4">
    <SessionStopped
      :start-session="startSession"
      :stop-session="stopSession"
      @close-modal="$emit('close-modal')"
    />
  </div>
</template>

<script>
import SessionStopped from "./SessionStopped.vue"

export default {
  name: "SessionControls",
  components: {
    SessionStopped,
  },
  props: {
    startSession: {
      type: Function,
      default: () => {},
    },
    stopSession: {
      type: Function,
      default: () => {},
    },
    sendClientEvent: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
